<template>


  <div style="background: rgb(244, 244, 244); min-height: 80vh">
    <div class="swiper" v-if="basic.isShowSwper == 1">
      <div class="main">
        <div class="block" :style="`width:${basic.swperFill==1?'100%':'52%'}`">
          <Carousel loop autoplay :autoplay-speed="3000" v-if="swipeList.length > 1">
            <CarouselItem v-for="item in swipeList" :key="item.id">
              <a :href="item.url" target="_blank">
                <img :src="item.img" alt="GEEK" :style="`height:${basic.swperFill==1?basic.swperHeight+'px':'165px'};border-radius:${basic.swperRadius}px`" />
              </a>
            </CarouselItem>
          </Carousel>
          <a  v-if="swipeList.length == 1" :href="swipeList[0].url"  target="_blank">
            <img :src="swipeList[0].img" alt="GEEK" :style="`height:${basic.swperFill==1?basic.swperHeight+'px':'165px'};border-radius:${basic.swperRadius}px`"  />
          </a>
        </div>
        <div class="gg" v-if="basic.swperFill == 0">
          <div class="hot-item" v-for="item in disShopList" :key="item.id" @click="$router.push('/details/' + item.id)">
            <Tag color="error" class="tag">折扣</Tag>
            <div class="hot-img">
              <img :src="item.front" alt="GEEK" />
            </div>
            <span class="new-price">¥ {{ item.newPrice }}</span>
            <span class="new-price init">¥ {{ item.price }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="goodsmenu" v-if="basic.isShowSwper == 1">
      <div class="main">
        <Select v-model="menuId" style="width: 150px">
          <Option v-for="item in menuList" :key="item.id" :value="item.id">{{
              item.name
            }}</Option>
        </Select>

        <span class="txtbar">本商城共有<b>{{total}}</b>件商品供您选择</span>
      </div>
    </div>
    <div class="skeleton" v-show="skeleton.goods">
      <Spin size="large" fix></Spin>
    </div>
    <div class="goodsbox">
      <div class="main">
        <div class="goods_nav" v-for="item in shopList" :key="item.id" @click="$router.push('/details/' + item.id)">
          <div class="goods_main">
            <img :src="item.front" class="goodsimg" alt />
            <div class="goodsname">
              <span class="tag" v-show="item.hot">推荐</span>
              {{ item.name }}</div>
            <div class="goodsprice">
              <em style="font-size: 12px">￥</em>
              {{ item.price }}
            </div>

            <!-- <div class="goods_foot">
              <Tag color="cyan" style="float: right">销量{{ item.sales }}</Tag>
              <Tag v-for="(item, index) in item.serve" :key="item" :color="color[index]" v-if="index < 2">{{ item }}
              </Tag>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="paging">
      <Page :total="Number(total)" :current="pageIndex" :page-size="Number(pageSize)" @on-change="pageChange" />
    </div>
    <!-- <div style="height:20px"></div> -->
  </div>

</template>

<script>
  import {
    getSwipe,
    getDisShop,
    getShop,
  } from "@/api/index";
  import {
    mapState,
  } from 'vuex'
  export default {
    data() {
      return {
        swipeList: [],
        disShopList: [],
        shopList: [],
        pageIndex: 1,
        total: "",
        loading: false,
        finished: false,
        skeleton: {
          hot: true,
          goods: true,
        },
        color: window.config.serve_color,
        groupId: "",
        menuId: 1,
        menuList: [{
            id: 1,
            name: "综合",
          },
          {
            id: 2,
            name: "最新发布",
          },
          {
            id: 3,
            name: "价格从低到高",
          },
          {
            id: 4,
            name: "价格从高到低",
          },
          {
            id: 5,
            name: "销量从高到低",
          },
        ],
      };
    },
    computed: {
      ...mapState(['pageSize','basic']),
    },
    watch: {
      menuId(newVal, oldVal) {
        if (newVal != oldVal) {
          this._getShop()
        }
      },
    },
    created() {
      this._getSwipe();
      this._getDisShop();
      this._getShop();
    },
    methods: {

      // 获取轮播图
      _getSwipe() {
        getSwipe().then((res) => {
          this.swipeList = res.data;
        });
      },
      // 获取折扣商品
      _getDisShop() {
        getDisShop().then((res) => {
          this.disShopList = res.data;
          this.skeleton.hot = false;
        });
      },
      // 获取商品
      _getShop() {
        getShop({
          pageIndex: this.pageIndex,
          name: "",
          menuId: this.menuId
        }).then((res) => {
          this.total = res.data.total
          this.shopList = res.data.data;
          this.skeleton.goods = false;
        });
      },
     


      // 分页跳转
      pageChange(val) {
        this.pageIndex = val;
        this._getShop();
      },

    },
  };
</script>

<style lang="less" scoped>
  @import "../../../../assets/css/clean.css";

  .page-template {
    background: #fff;

    .swiper {
      // height: 200px;

      .main {
        margin: 0 auto;
        width: 100%;
        overflow: hidden;
        // height: 185px;
        max-width: 1230px;
        padding-top: 15px;

        .block {
          width: 52%;
          // height: 180px;
          float: left;

          // margin-right: 2%;
          img {
            width: 100%;
            height: 300px;
          }
        }

        .gg {
          display: inline-block;
          float: left;
          width: 48%;
          height: 160px;
          // background: #fff;
          border-radius: 5px;

          .hot-item {
            width: 22%;
            float: left;
            margin-left: 3%;
            background: #ffffff;
            position: relative;
            cursor: pointer;

            .tag {
              position: absolute;
              top: 10px;
              right: -4px;
            }

            .hot-img {
              // padding: 0 10px;
              height: 120px;

              img {
                width: 100%;
                height: 120px;
                border-radius: 2px;
              }
            }

            .new-price {
              display: block;
              color: #f2270c;
              font-size: 17px;
              line-height: 20px;
              font-weight: 600;
              text-align: center;
              font-family: JDZhengHT-EN-Regular;
            }

            .init {
              text-decoration: line-through;
              font-size: 13px;
              font-weight: 1;
              color: #999;
            }
          }

          .gg_cont {
            border: 1px solid #ccc;
            border-radius: 5px;
            height: 160px;

            .gg_name {
              padding: 6px;
              font-size: 18px;
              font-weight: 600;
              border-bottom: 1px solid #ccc;
            }

            .gg_sm {
              padding: 6px;
              font-size: 14px;
              overflow: hidden;
            }
          }
        }
      }
    }

    .goodsmenu {
      margin-left: auto;
      margin-right: auto;
      margin-top: 10px;
      width: 100%;

      max-width: 1230px;

      .main {
        padding: 10px;
        background-color: #fff;
        // border: solid 1px #ddd;
        border-radius: 2px;
        line-height: 30px;
        font-size: 14px;
        color: #555;

        .txtbar {
          padding-left: 10px;
          font-size: 12px;
          color: #777;
          letter-spacing: 1px;

          b {
            color: red;
          }
        }
      }
    }

    .goodsbox {
      overflow: hidden;
      background: rgb(244, 244, 244);

      .main {
        margin: 0 auto;
        width: 100%;
        max-width: 1230px;

        .goods_title {
          border: 1px solid #ddd;
          height: 40px;
          font-size: 17px;
          line-height: 40px;
          padding: 0 10px;

          a {
            cursor: pointer;
            font-weight: 600;
          }
        }

        .goods_nav {
          width: 246px;
          height: 325px;
          border: solid 5px transparent;
          border-radius: 2px;
          float: left;
          margin-top: 5px;
          position: relative;

          .goods_main {
            width: 100%;
            height: 315px;
            padding-top: 5px;
            border-radius: 2px;
            background-color: #fff;

            .goodsimg {
              display: block;
              width: calc(100% - 10px);
              height: 225px;
              cursor: pointer;
              margin: 0 5px;
              object-fit: cover;
              background-repeat: no-repeat;
              border-radius: 2px;
            }


            .goodsname {
              height: 42px;
              margin: 0 10px;
              font-size: 14px;
              margin-top: 10px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;

              .tag {
                padding: 1px 4px;
                border-radius: 999px;
                background-color: #ee0a24;
                color: #fff;
                font-size: 12px;
                line-height: 16px;
              }
            }

            .goodsprice {
              margin: 0 10px;
              font-size: 18px;
              color: red;
              font-weight: 600;
            }

            .goods_tool {
              border-top: 1px solid #ddd;
              font-size: 12px;
              height: 36px;

              .sales {
                float: left;
                width: 49%;
                height: 35px;
                line-height: 35px;
                text-align: center;
                color: #999;
              }
            }

            .goods_foot {
              margin: 2%;
              overflow: hidden;
            }
          }


        }
      }
    }

    .skeleton {
      height: 50vh;
      position: relative;
      background: rgb(244, 244, 244);

      .ivu-spin-fix {
        background: rgb(244, 244, 244);
      }
    }

    .paging {
      text-align: center;
      margin-top: 20px;
      height: 50px;
    }

    .active {
      background: #0066ff;
      border-bottom: 1px solid #0066ff;
    }
  }
</style>